function ExampleController(){
	this.className			= "ExampleController";
	this.view				= false; //"example";
	this.glob				= ["/view/example/", "/example/"];
	this.viewData			= {};
}
ExampleController.inheritsFrom( PageController );

ExampleController.prototype.on = function(onComplete){
	this.$body				= $('body');
	return true;
}
